import { z } from 'zod';
import ValidationErrors from '@/Utils/ValidationErrors';

export const isUrl = (value: string) =>
    /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/.test(value);

const isLinkedInProfileUrl = (value: string) => {
    if (!isUrl(value)) {
        return true;
    }

    let url: URL;
    try {
        url = new URL(value);
    } catch {
        if (!URL.canParse(`https://${value}`)) {
            return false;
        }
        url = new URL(`https://${value}`);
    }

    const hasHttpProtocol = url.protocol === 'http:' || url.protocol === 'https:';
    return hasHttpProtocol && url.hostname === 'www.linkedin.com' && url.pathname.startsWith('/in/');
};

export const linkedInFormSchema = z.object({
    linkedInId: z
        .string()
        .min(1, ValidationErrors.Required)
        .refine(isLinkedInProfileUrl, ValidationErrors.UrlMustBeFromLinkedIn),
});

export type LinkedInFormSchema = z.infer<typeof linkedInFormSchema>;
